import React, { useEffect } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { ErrorCodes } from '../../components/docomo/ErrorCodes';
import { HTTPStatus } from '../../utils/enum';

export default function DocomoHandler() {
const location = useLocation();
const navigate = useNavigate();
useEffect(() => {
    // This is where you would handle the response from the dアカウント login
    // For example, you might want to parse the URL parameters and store them in state or context
    const urlParams = new URLSearchParams(location.search);
    const error = urlParams.get('error');
    const callCheckSubscription = async () => {
        // This function would typically handle the creation of a subscription.
        try {
            const code = urlParams.get('code');
            const nonce = urlParams.get('state');
            const baseUrl = process.env.REACT_APP_PARTNER_PAGES_BACKEND_URL;
            const response = await axios.get(`${baseUrl}/docomo/checkSubscription?code=${code}&nonce=${nonce}`);
            if (response.status === HTTPStatus.OK) {
                // Subscription exists, redirect to DisplaySupportId page
                navigate('/DisplaySupportId', {
                    state: { 
                        supportId: response.data.data.supportId, 
                        cust_context_id: response.data.data.cust_context_id,
                        signedAt: response.data.data.signedAt,
                        signedCCID: response.data.data.signature
                    }   
                })
            }
            else if (response.status === HTTPStatus.ACCEPTED) {
                // Subscription not exists, redirect to CollectSupportId page to create subscription
                navigate('/CollectSupportId', {
                    state: { 
                        docomoId: response.data.data.accountId, 
                        signature: response.data.data.signature,
                        isRestartSubscription: response.data.data.isRestartSubscription
                    }   
                })
            }
        } catch (error) {
            // Handle error in subscription creation
            console.error("Error creating subscription:", error);
            if (error.response && error.response.status === HTTPStatus.PAYMENT_REQUIRED) {
                // If the error is a 402 - payment required
                navigate(`/Login?errorCode=${encodeURIComponent('M-001')}`)
            }
            else if (error.response && error.response.status === HTTPStatus.UNPROCESSABLE_ENTITY) {
                // Error at Docomo side
                navigate(`/Login?errorCode=${encodeURIComponent('D-099')}`)
            }
            else {
                // navigate to error page
                navigate(`/Login?errorCode=${encodeURIComponent('M-000')}`)
            }
            
        }
       
    };

    if (error) {
      // If there is an error code, redirect to the login page with the error code
      const errorCode = ErrorCodes[error] || 'D-099'; // Default to 'D-099' if error code is not found
      navigate(`/Login?errorCode=${encodeURIComponent(errorCode)}`);

    } else {
      // Call check subscription API and based on response code, redirect to the appropriate page
      callCheckSubscription()
    }
  }, [location.search, navigate]);

  return (
    <div></div>
  )
}
